'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'

import { ReviewsContainer } from '../shared/reviews-container'

export const ReviewsFullWidget: PLTypedWidgetInterface<never, WidgetType.REVIEWS_FULL> = {
  id: WidgetType.REVIEWS_FULL,
  errorBoundary: PLBaseErrorBoundary,
  render: (props: PLTypedWidgetProps<never>) => (
    <ReviewsContainer variant="full" renderedChildren={props.renderedChildren} />
  ),
}
